import React, {Component} from 'react';
import {connect} from 'react-redux';

import {fetchReference} from "./actions/reference";

import ReferenceForm from './ReferenceForm';
import Loader from "../../components/display/Loader";
import {setFooterVisibility, setNavbarVisibility} from "../navigation/actions/navbar";

class ReferenceContainer extends Component {
    state = {
        showForm: false
    };

    componentWillMount() {
        this.props.onLoad();
    }

    render() {
        const {reference, params} = this.props;

        return (
            <Loader spin isLoading={!reference.name}>
                <ReferenceForm params={params}/>;
            </Loader>
        );
    }
}

const mapStateToProps = (state) => ({
    reference: state.reference,
});

const mapDispatchToProps = (dispatch, props) => ({
    onLoad() {
        dispatch(setNavbarVisibility(false));
        dispatch(setFooterVisibility(false));
        return dispatch(fetchReference(props.params.rental_id, props.params.key));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ReferenceContainer);


// WEBPACK FOOTER //
// ./src/containers/reference/ReferenceContainer.js